import React from 'react';
import { chakra, Flex, Text, useCheckbox } from '@chakra-ui/react';
import { ICategoryValue } from '../category';
import { ActionCancelIcon } from '../../../../../utils/icons/actionCancel';

export const Checkable = (props: { data: ICategoryValue } | any) => {
	const { state, getCheckboxProps, getInputProps, getLabelProps, htmlProps } = useCheckbox(props);

	return (
		<chakra.label
			display="flex"
			alignItems="baseline"
			gridGap="8px"
			cursor="pointer"
			{...htmlProps}
		>
			<input
				{...getInputProps()}
				hidden
			/>
			<Flex
				{...getCheckboxProps()}
				display={state.isChecked ? 'flex' : 'none'}
			>
				<ActionCancelIcon />
			</Flex>
			<Flex
				alignItems="stretch"
				gridGap="8px"
				opacity={state.isChecked ? 'unset' : '.5'}
			>
				<Text
					{...getLabelProps()}
					fontWeight={state.isChecked ? '700' : 'unset'}
				>
					{props.data.name}
				</Text>
				{props.data.icon}
			</Flex>
		</chakra.label>
	);
};
